'use es6';

import { connect } from 'react-redux';
import { getSelectedThread } from '../../selected-thread/selectors/getSelectedThread';
import ConnectedChatAreaAlertContainer from '../../threads/containers/ConnectedChatAreaAlertContainer';
const mapStateToProps = state => ({
  thread: getSelectedThread(state)
});
export default connect(mapStateToProps)(ConnectedChatAreaAlertContainer);